import * as yup from "yup";
import moment from "moment";

declare module "yup" {
   export interface StringSchema {
      /**
       * Check for date string validity.
       *       
       * @param {Boolean} [required=false] Is date required.
       * @param {String} [errorMessage=DEFAULT_MESSAGE] The error message to return if the validation fails.
       */
      dateString(
         required: boolean,
         errorMessage?: string
      ): StringSchema;
   }
}
const YUP_DATE_STRING_METHOD = "dateString";
yup.addMethod(yup.string, YUP_DATE_STRING_METHOD, function yupDateString(
   required: boolean,
   errorMessage = ""
) {
   const errMsg =
      typeof errorMessage === "string" && errorMessage
         ? errorMessage
         : "Date is required.";

   return this.test(YUP_DATE_STRING_METHOD, errMsg, (value: string) => {
      if (!value)
         return !required;
      else 
         return moment(value).isValid();
   });
});
